// extracted by mini-css-extract-plugin
export var linkText = "_q8-0";